import * as React from 'react'
import { Badge, Title } from '@mantine/core'

import * as Types from '../../declarations'
import HTMLContent from 'components/HTMLContent'
import AccountNudge from 'components/AccountNudge'

const ArticlePage = ({
	article,
	imageUrl,
	version,
	trips,
}: {
	article: Types.DB.Models.ArticleAttributes
	imageUrl: string
	version: Types.VERSION
	trips: Types.App.HomePageTrip[]
}) => {
	const renderContentWithShortcodes = (content: string): string => {
		return content.replace(
			/\[(tripcards|tripmap|image_gallery) ids=([0-9, ]+)\]/g,
			(match, shortcode, idsString) => {
				// Add placeholders for each shortcode
				return `<div data-shortcode="${shortcode}" data-ids="${idsString}"></div>`
			},
		)
	}

	return (
		<div id="article-page">
			{article?.liveJson?.customStyles && (
				<style
					dangerouslySetInnerHTML={{ __html: article.liveJson.customStyles }}
				/>
			)}
			<div className="hero" style={{ backgroundImage: `url(${imageUrl})` }}>
				<div className="headline">
					<div className="limit-w">
						<div className="title-wrapper">
							<h1 className="hero-title">{article.title}</h1>
							{!!article?.liveJson.subtitle && (
								<h2 className="hero-subtitle">{article.liveJson.subtitle}</h2>
							)}
						</div>
					</div>
				</div>
			</div>

			<div className="article-column">
				<div className="article-content">
					<HTMLContent
						html={renderContentWithShortcodes(article.liveJson.content)}
						trips={trips}
						version={version}
					/>
				</div>

				{(article?.liveJson?.tags ?? []).length > 0 && (
					<div className="article-tags">
						<Title order={3} mt="xl" mb="sm">
							Tagged under
						</Title>
						<div className="tags-container">
							{article.liveJson.tags.map((tag, i) => (
								<div key={i} className="article-tag">
									{tag}
								</div>
							))}
						</div>
					</div>
				)}
				<AccountNudge variant="alert" version={version} />
			</div>
		</div>
	)
}

export default ArticlePage
